<div class="flex gap-x-2 mb-2">
  <tui-input
    class="w-4/12"
    tuiTextfieldSize="m"
    [formControl]="memberForm.controls.name"
    >ФИО
  </tui-input>
  <tui-input
    class="w-3/12"
    tuiTextfieldSize="m"
    [formControl]="memberForm.controls.position"
    >Должность
  </tui-input>
  <div class="flex flex-col gap-y-2 w-3/12">
    @for (
      contact of memberForm.controls.contacts.controls;
      track index;
      let lastContact = $last;
      let index = $index
    ) {
      <div class="flex gap-x-2 items-center">
        <app-autocomplete
          [items]="contactTypes"
          [itemSearch]="'itemSearch'"
          [itemText]="'text'"
          [itemValue]="'value'"
          [displayValue]="'text'"
          class="w-6/12"
          tuiTextfieldSize="m"
          [labelOutside]="false"
          [formControl]="contact.controls.type"
          label="Тип"
        >
        </app-autocomplete>
        <tui-input
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="contact.controls.value"
          >Значение
        </tui-input>

        <div class="flex gap-x-2 w-1/12 items-center">
          <button
            appearance="secondary-destructive"
            size="s"
            (click)="removeContact(index)"
            tuiIconButton
            icon="tuiIconTrash"
          ></button>
          @if (lastContact) {
            <button
              appearance="secondary"
              size="s"
              (click)="addContact()"
              tuiIconButton
              icon="tuiIconPlus"
            ></button>
          }
        </div>
      </div>
    } @empty {
      <button
        class="w-fit"
        size="s"
        tuiButton
        icon="tuiIconPlus"
        (click)="addContact()"
      >
        Добавить контакт
      </button>
    }
  </div>
  <div class="flex gap-x-2 mr-0 ml-auto w-1/12 mt-1.5">
    <button
      appearance="accent"
      size="s"
      (click)="remove.emit()"
      tuiIconButton
      icon="tuiIconTrash"
    ></button>
    @if (last) {
      <button
        size="s"
        (click)="create.emit()"
        tuiIconButton
        icon="tuiIconPlus"
      ></button>
    }
  </div>
</div>
